/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Card, Text, TextSize } from '@sonarsource/echoes-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStandardExperienceModeQuery } from '~sq-server-commons/queries/mode';
import { SandboxProjectSettings } from '../../types';
import { mapQualitiesAndSeveritiesToLabels } from '../../utils';

type SandboxSettingQualitiesSectionReadonlyProps = {
  projectSettigs?: SandboxProjectSettings;
};

export default function SandboxSettingQualitiesSectionReadonly({
  projectSettigs,
}: Readonly<SandboxSettingQualitiesSectionReadonlyProps>) {
  const { data: isStandardExperience } = useStandardExperienceModeQuery();
  const intl = useIntl();

  const qualities = mapQualitiesAndSeveritiesToLabels(intl, projectSettigs, isStandardExperience);

  if (!qualities) {
    return null;
  }

  return (
    <Card className="sw-mt-4">
      <Card.Header
        description={
          <Text size={TextSize.Small}>
            <FormattedMessage id="settings.sandbox_issues.project.qualities.description" />
          </Text>
        }
        hasDivider
        title={
          <FormattedMessage
            id={`settings.sandbox_issues.project.qualities.title.${isStandardExperience ? 'standard' : 'mqr'}`}
          />
        }
      />
      <Card.Body>
        <ul className="sw-ml-5">
          {qualities.map((q) => (
            <li className="sw-mt-1 sw-list-disc sw-ml-1" key={q.label}>
              <Text isHighlighted>{q.label}</Text>
              <span>: </span>
              <FormattedMessage
                id="settings.sandbox_issues.project.default_settings.severities"
                values={{
                  severities: q.severities.join(', '),
                  count: q.severities.length,
                }}
              />
            </li>
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
}
